import i18n from '@speechki-frontend/core/i18n/i18n';
import { LoginPage, ProfilePage, PasswordResetPage } from './views';

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: {
            guest: true,
            title: i18n.global.t('routes.login'),
        },
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: PasswordResetPage,
        meta: {
            guest: true,
            title: i18n.global.t('login.reset.title'),
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component: ProfilePage,
        meta: {
            title: i18n.global.t('routes.profile'),
        },
    },
];

export default routes;
